<template>
    <transition :name="animation">
        <div
            class="loading-overlay is-active"
            :class="{ 'is-full-page': isFullPage }">
            <div class="loading-background"/>
            <bmr-spinner></bmr-spinner>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'bmr-busy',
    props: {
        active: Boolean,
        isFullPage: {
            type: Boolean,
            default: false,
        },
        animation: {
            type: String,
            default: 'fade',
        },
    },
};
</script>

<style lang="scss" scoped>
$speed-slow: 150ms !default;
$easing: ease-out !default;

.loading-overlay {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    z-index: 999;
    &.is-active {
        display: flex;
    }
    &.is-full-page {
        z-index: 999;
        position: fixed;
        >>> .loading-icon {
            position: absolute;
            top: calc(50% - 1.5em);
            left: calc(50% - 1.5em);
            top: calc(50% - 2.5em);
            left: calc(50% - 2.5em);
            width: 5em;
            height: 5em;
            z-index: 1000;
        }
    }
    .loading-background {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #7f7f7f;
        background: rgba(255,255,255,0.7);
    }
}

// Fade
.fade-enter-active,
.fade-leave-active {
    transition: opacity $speed-slow $easing;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrBusy.vue